import axiosInstance from './axios-instance';
import type { ColumnVisibilityPage } from '../helper/columnVisibilityPreference';

export type ColumnVisibilityPreferenceVisibility = {
  columns?: Record<string, boolean>;
  assignmentColumns?: Record<number | string, boolean>;
  customColumns?: CustomColumnPreference[];
};

export type CustomColumnPreference = {
  id: string;
  name: string;
  inputType: 'text' | 'dropdown';
  options: string[];
};

export type ColumnVisibilityPreferenceResponse = {
  page: ColumnVisibilityPage;
  accountId: number;
  visibility?: ColumnVisibilityPreferenceVisibility;
};

export const getColumnVisibilityPreference = async (payload: {
  accountId: number;
  page: ColumnVisibilityPage;
}): Promise<ColumnVisibilityPreferenceResponse> => {
  const response = await axiosInstance.get(
    `/column-visibility-preferences/get?accountId=${payload.accountId}&page=${encodeURIComponent(payload.page)}`
  );
  return response.data;
};

export const upsertColumnVisibilityPreference = async (payload: {
  accountId: number;
  page: ColumnVisibilityPage;
  visibility: ColumnVisibilityPreferenceVisibility;
}): Promise<ColumnVisibilityPreferenceResponse> => {
  const response = await axiosInstance.put('/column-visibility-preferences/upsert', payload);
  return response.data;
};

export const saveCustomColumnsPreference = async (payload: {
  accountId: number;
  page: ColumnVisibilityPage;
  customColumns: CustomColumnPreference[];
}): Promise<ColumnVisibilityPreferenceResponse> => {
  const response = await axiosInstance.put('/column-visibility-preferences/save-custom-columns', payload);
  return response.data;
};
